/**
 * createMatchEndHonorChipController — Match-end honor/MVP chip (SPY-415 / SPY-515).
 */

export function createMatchEndHonorChipController({
  rootEl,
  honorBtnEl,
  mvpBtnEl,
  echoEl = null,
  onHonor,
  onMvp
} = {}) {
  let visible = false;
  let lastEcho = '';

  function show() {
    if (!rootEl) return false;
    rootEl.hidden = false;
    rootEl.setAttribute?.('aria-hidden', 'false');
    visible = true;
    return true;
  }

  function hide() {
    if (!rootEl) return;
    rootEl.hidden = true;
    rootEl.setAttribute?.('aria-hidden', 'true');
    visible = false;
  }

  function isVisible() {
    return visible;
  }

  function setLastActionEcho(text) {
    lastEcho = (text === undefined || text === null) ? '' : String(text);
    if (echoEl) echoEl.textContent = lastEcho;
    return lastEcho;
  }

  function getLastActionEcho() {
    return lastEcho;
  }

  if (honorBtnEl && typeof honorBtnEl.addEventListener === 'function') {
    honorBtnEl.addEventListener('click', () => {
      if (typeof onHonor === 'function') onHonor();
    });
  }
  if (mvpBtnEl && typeof mvpBtnEl.addEventListener === 'function') {
    mvpBtnEl.addEventListener('click', () => {
      if (typeof onMvp === 'function') onMvp();
    });
  }

  return { show, hide, isVisible, setLastActionEcho, getLastActionEcho };
}
